import script from "./DocumentSectionSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentSectionSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentSectionSkeleton.vue?vue&type=style&index=0&id=6439c7f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6439c7f8"]])

export default __exports__